/* The border and padding sit INSIDE the 100 % (F-UIX-016): otherwise a full-width field is wider than a phone. */
.input {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  block-size: var(--control-height);
  padding: 0 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
}

/* The measured ring drawn over the border (offset -1px), plus the mockup's soft
   halo: it reads as the mockup's accent border and stays 3:1 (decision D-UX-5). */
.input:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
  box-shadow: 0 0 0 3px var(--action-soft);
}

.input[aria-invalid="true"] {
  border-color: var(--danger-text);
}

.input::placeholder {
  color: var(--text-subtle);
}

.input:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
